import React, { useState, useEffect, useRef } from 'react';
import Select from 'react-select';
import 'react-phone-number-input/style.css';
import PhoneInput, { isValidPhoneNumber } from 'react-phone-number-input';

import { useNavigate, useParams } from 'react-router';
import GeneratePasswordModal from './/modals/GeneratePasswordModal';
import { useDispatch } from 'react-redux';
import Scroller from 'ui-component/Scroller';
import { FaPlus, FaSave } from 'react-icons/fa';
import toast from 'react-hot-toast';
import PermissionAllowed from 'ui-component/permissions/PermissionAllowed';
import useIsMobile from 'utils/isMobileUtils';

// ✅ Clear
const UserForm = ({ edit }) => {
	const { id } = useParams();

	const history = useNavigate();
	const firstnameRef = useRef();
	const lastnameRef = useRef();
	const emailRef = useRef();
	const roleRef = useRef();
	const mobileRef = useRef();
	const passwordRef = useRef();
	const [showGeneratePasswordModal, setShowGeneratePasswordModal] = useState(false);
	const [userInfo, setUserinfo] = useState({
		fname: '',
		lastname: '',
		emailid: '',
		mobile: '',
		role: '',
		status: 1,
		password: '',
		is_salesperson: null
	});

	const [alertMessage, setAlertmessage] = useState({});
	const [roles, setRoles] = useState([]);
	const [selectedRole, setSelectedRole] = useState([]);
	const [notvalidPhone, setnotvalidPhone] = useState(true);
	const [showPasswordField, setShowPasswordField] = useState(true);
	const getRoleData = () => {
		api.getRoles().then((res) => {
			const transformedOptions = res.data.map((item) => ({ label: item.name, value: item.id }));
			setRoles(transformedOptions);
		});
	};
	const handleChange = (val) => {
		setUserinfo(val);
	};

	useEffect(() => {
		if (edit && id) {
			// setIsloading(true);
			api.getUserDetail(id).then((res) => {
				if (res && res.status) {
					setUserinfo({
						fname: res?.data?.first_name,
						lastname: res?.data?.last_name,
						emailid: res?.data?.email,
						mobile: res?.data?.mobile,
						role: res?.data?.role?.id,

						status: 1,
						is_salesperson: res?.data?.is_salesperson ? true : false
					});
					setSelectedRole({ label: res?.data?.role?.name, value: res?.data?.role?.id });
					// setIsloading(false);
				} else {
					history('/settings/user');
				}
			});
			setShowPasswordField(false);
		} else {
			setShowPasswordField(true);
		}
	}, []);

	useEffect(() => {
		setUserinfo((olddata) => ({ ...olddata, role: selectedRole?.value || '' }));
	}, [selectedRole]);
	
	const fnamehandle = (e) => {
		let inputValue = e.target.value;
		const onlyAlphabets = /^[A-Za-z ]+$/;
		if (onlyAlphabets.test(inputValue) || inputValue === '') {
			const words = inputValue.split(' ');
			const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase());
			inputValue = capitalizedWords.join(' ');
			handleChange({ ...userInfo, fname: inputValue });
		}
	};
	const lnamehandle = (e) => {
		let inputValue = e.target.value;
		const onlyAlphabets = /^[A-Za-z ]+$/;
		if (onlyAlphabets.test(inputValue) || inputValue === '') {
			const words = inputValue.split(' ');
			const capitalizedWords = words.map((word) => word.charAt(0).toUpperCase() + word.substr(1).toLowerCase());
			inputValue = capitalizedWords.join(' ')?.trim();
			handleChange({ ...userInfo, lastname: inputValue });
		}
	};

	const handleEmail = (e) => {
		const inputValue = e.target.value;
		const lowercaseValue = inputValue.toLowerCase();
		e.target.value = lowercaseValue;
	};
	
	const handleRole = (event) => {
		setSelectedRole(event);
	};
	const handleSubmit = (e) => {
		e.preventDefault();
		if (userInfo.fname?.trim() == '') {
			toast.error('First Name is required.');
			firstnameRef.current.focus();
		} else if (userInfo.lastname?.trim() == '') {
			toast.error('Last Name is required.');
			lastnameRef.current.focus();
		} else if (userInfo.emailid == '') {
			toast.error('Email is required');
			emailRef.current.focus();
		} else if (!/^[A-Za-z0-9._%+-]+@[A-Za-z0-9.-]+\.[A-Za-z]{2,}$/.test(userInfo.emailid)) {
    		toast.error('Invalid email format');
			emailRef.current.focus();
		} else if (!notvalidPhone) {
			toast.error('Phone Number is not in valid format.');
			mobileRef.current.focus();
		} else if (!userInfo?.role) {
			toast.error('Role is required.');
			roleRef.current.focus();
		} else if (!edit && userInfo.password.trim() == '') {
			toast.error('Password is required.');
			passwordRef.current.focus();
		} else {
			const request = {
						first_name: userInfo.fname,
						last_name: userInfo?.lastname || '',
						email: userInfo?.emailid,
						mobile: userInfo?.mobile || '',
						role_id: userInfo?.role,
						password: userInfo?.password || '',
						status: userInfo?.status
			}
			if (edit) {

				api.updateUser(id, request).then(
					(res) => {
						if (res.status) {
							toast.success(res.message);
							history(`/settings/user`);
						} else {
							toast.error(res.message);
						}
					},
					() => { }
				);
			} else {
				api.createUser(request).then(
					(res) => {
						if (res.status) {
							toast.success(res.message);
							history(`/settings/user`);
						} else {
							toast.error(res.message);
						}
					},
					() => { }
				);
				
			}
		}
		setTimeout(() => {
			setAlertmessage('');
		}, 3000);
	};
	useEffect(() => {
		getRoleData();
	}, []);
	const goback = () => {
		history('/settings/user');
	};

	const isMobile = useIsMobile();

	return (
		<>
			<div className={`row m-0 ${isMobile ? '' : 'create-contact-container'}`}>
				<div className="show-on-mobile new-page-header" style={{ position: 'relative' }}>
					<div className="header-bubble" />
					<div className="d-flex flex-column gap-2 " style={{ position: 'relative', zIndex: 1, paddingTop: 10, width: '100%' }}>
						<div
							style={{
								position: 'relative',
								display: 'flex',
								alignItems: 'center',
								justifyContent: 'center',
								marginBottom: 8,
								minHeight: 38 // ensures enough height for the button
							}}
						>
							{' '}
							<button
								type="button"
								aria-label="Back"
								onClick={() => history(-1)}
								className="circle-back-btn"
								style={{
									position: 'absolute',
									left: 20,
									top: '50%',
									transform: 'translateY(-50%)'
								}}
							>
								{/* Replace with your fi arrow icon, example below */}
								<svg width="22" height="22" fill="none" viewBox="0 0 24 24">
									<path d="M15 19l-7-7 7-7" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />
								</svg>
							</button>
							<h5 style={{ textAlign: 'center', flex: 1, margin: 0 }}> {edit ? 'Edit User' : 'Create User'}</h5>
						</div>
						<div style={{ width: '100%', display: 'flex', justifyContent: 'center' }}>
							{edit ? (
								<PermissionAllowed permissions={['Save User Details (Action)']}>
									<button
										type="submit"
										className="btn btn-primary btn-outlined-main"
										// disabled={isSubmitDisabled}
										onClick={handleSubmit}
									>
										<FaSave /> Save Changes
									</button>
								</PermissionAllowed>
							) : (
								<PermissionAllowed permissions={['Create New User (Action)']}>
									<button
										type="submit"
										className="btn btn-primary btn-outlined-main"
											// disabled={isSubmitDisabled}
											onClick={handleSubmit}
									>
										<FaPlus /> Create
									</button>
								</PermissionAllowed>
							)}
						</div>
					</div>
				</div>
				<div className={`${isMobile ? 'mobile-scroll-container w-100 mobile-scroll-container-smaller' : 'card w-100 h-100 '}`}
									style={{ marginTop: isMobile ? '0px' : '20px', paddingBottom: isMobile ? '90px' : '' }}
>
					<form action="" className="h-100" onSubmit={handleSubmit}>
						<div className="section-head m-0 p-0 hide-on-mobie">
							<h5 className="m-0 p-0 pb-2" style={{ fontWeight: '500' }}>
								{edit ? 'Edit User' : 'Create User'}
							</h5>
						</div>
						<Scroller>
							<div className="form-section">
								<div className="form-group">
									<div className="form-group-body">
										<label htmlFor="">
											First Name <sup className="text-danger">*</sup>
										</label>
										<div>
											<input
												ref={firstnameRef}
												type="text"
												className="form-control"
												id="inputName"
												value={userInfo.fname}
												maxLength={15}
												onChange={(e) => {
													fnamehandle(e);
												}}
											/>
										</div>
									</div>
									<div className="form-group-error">
										{alertMessage.firstname && (
											<span className="error-message text-danger">{alertMessage.message}</span>
										)}
									</div>
								</div>

								<div className="form-group">
									<div className="form-group-body">
										<label htmlFor="">
											Last Name <sup className="text-danger">*</sup>
										</label>
										<div>
											<input
												ref={lastnameRef}
												type="text"
												className="form-control"
												id="inputName"
												value={userInfo.lastname}
												maxLength={15}
												onChange={(e) => {
													lnamehandle(e);
												}}
											/>
										</div>
									</div>
									<div className="form-group-error">
										{alertMessage.lastname && (
											<span className="error-message text-danger">{alertMessage.message}</span>
										)}
									</div>
								</div>

								<div className="form-group">
									<div className="form-group-body">
										<label htmlFor="">
											Email <sup className="text-danger">*</sup>
										</label>
										<div>
											<input
												ref={emailRef}
												type="email"
												className="form-control"
												id="inputName"
												value={userInfo.emailid}
												autoComplete="off"
												onChange={(e) => {
													handleEmail(e);
													handleChange({ ...userInfo, emailid: e.target.value });
												}}
											/>
										</div>
									</div>
									<div className="form-group-error">
										{alertMessage.emailid && (
											<span className="error-message text-danger">{alertMessage.message}</span>
										)}
									</div>
								</div>

								<div className="form-group">
									<div className="form-group-body">
										<label htmlFor="">Phone Number</label>
										<div>
											<PhoneInput
												value={userInfo?.mobile}
												defaultCountry="AE"
												addInternationalOption={false}
												onChange={(phone) => {
													if (phone && !isValidPhoneNumber(phone)) {
														setnotvalidPhone(false);
													} else {
														setnotvalidPhone(true);
													}
													handleChange({ ...userInfo, mobile: phone });
												}}
											/>
										</div>
									</div>
									<div className="form-group-error">
										{alertMessage.mobile && (
											<span className="error-message text-danger">{alertMessage.contactPhone}</span>
										)}
									</div>
								</div>

								<div className="form-group">
									<div className="form-group-body">
										<label htmlFor="">
											Role <sup className="text-danger">*</sup>
										</label>
										<div>
											<Select
												className="rs-container"
												classNamePrefix="rs"
												labelName={'Role'}
												name={'role'}
												value={selectedRole}
												options={roles}
												onChange={handleRole}
												menuPosition="fixed"
												placeholder=""
											/>
										</div>
									</div>
									<div className="form-group-error">
										{alertMessage.roleis && (
											<span className="error-message text-danger">{alertMessage.message}</span>
										)}
									</div>
								</div>

								{edit && (
									<div className="form-group">
										<div className="form-group-body">
											<label htmlFor="">
												Does Sales? <sup className="text-danger">*</sup>
											</label>
											<div>
												<Select
													className="rs-container"
													classNamePrefix="rs"
													labelName={'Role'}
													name={'role'}
													value={[
														{ label: 'Yes', value: true },
														{ label: 'No', value: false }
													]?.find((a) => a.value == userInfo?.is_salesperson)}
													options={[
														{ label: 'Yes', value: true },
														{ label: 'No', value: false }
													]}
													menuPosition="fixed"
													placeholder=""
													onChange={(e) => {
														setUserinfo((oldData) => ({
															...oldData,
															is_salesperson: e.value
														}));
													}}
												/>
											</div>
										</div>
									</div>
								)}
								{
									showPasswordField ? (
										<div className="form-group">
											<div className="form-group-body">
												<label htmlFor="" style={{ marginTop: '-35px' }}>
													Password <sup className="text-danger">*</sup>
												</label>
												<div>

													<div>
														<input
															ref={passwordRef}
															type="password"
															className="form-control"
															id="inputName"
															value={userInfo.password}
															maxLength={15}
															onChange={(e) => {
																handleChange({ ...userInfo, password: e.target.value });
															}}
														/>
													</div>
													<div style={{ marginTop: '5px' }}>
														<button
															type="button"
															className="btn btn-primary btn-outlined-main"
															onClick={() => {
																setShowGeneratePasswordModal(true);
															}}
														>
															Generate Password
														</button>
													</div>
												</div>
											</div>
										</div>
									) : (
										<div className="form-group">
											<div className="form-group-body">
												<label htmlFor=""> </label>
												<div>

													<div style={{ marginTop: '5px' }}>
														<button
															type="button"
															className="btn btn-primary btn-outlined-main"
															onClick={() => {
																setShowPasswordField(true);
															}}
														>
															Reset Password
														</button>
													</div>
												</div>
											</div>
										</div>
											
									)
								}
							</div>
						</Scroller>
						{!isMobile && (<div className="non-scroll-btn-section">
							<div className="btnarea">
								<button onClick={goback} className="btn btn-link">
									Cancel
								</button>
								{edit ? (
									<PermissionAllowed permissions={['Save User Details (Action)']}>
										<button
											type="submit"
											className="btn btn-primary btn-outlined-main"
										>
											<FaSave /> Save Changes
										</button>
									</PermissionAllowed>
								) : (
									<PermissionAllowed permissions={['Create New User (Action)']}>
										<button
											type="submit"
											className="btn btn-primary btn-outlined-main"
											// disabled={isSubmitDisabled}
										>
											<FaPlus /> Create
										</button>
									</PermissionAllowed>
								)}
							</div>
							{alertMessage.success && <span className="px-3 down-error text-success">{alertMessage.success}</span>}
							{alertMessage.failed && <span className="px-3 down-error text-danger">{alertMessage.failed}</span>}
						</div>)}
					</form>
				</div>
			</div>
			{showGeneratePasswordModal && (
				<GeneratePasswordModal	
					openPopup={showGeneratePasswordModal}
					details={userInfo?.password}
					handleSubmit={(generatedPassword) => {
						handleChange({ ...userInfo, password: generatedPassword });
						setShowGeneratePasswordModal(false);
					}}
					handleClose={() => setShowGeneratePasswordModal(false)}
				/>
			)}
				
		</>
	);
};

export default UserForm;
